export const hello = () => 'hello';

export * from './order-notice';
